import React, { useState, useEffect  } from 'react';
import './../../entrydoor.css';

const TransomLite = ({ value, onChange, label = 'Transom Lite', childs=[], 
    doorSizeValueToFunc,doorHeightValueToFunc, passSelectedDoor }) => {
    const [selectedTransomLite, setSelectedTransomLite] = useState(value || "");
    const visibleShapes = ["Other"];

    useEffect(() => {
        if (passSelectedDoor) { }
        if (doorSizeValueToFunc) {}
        if (doorHeightValueToFunc) {}
      }, [doorSizeValueToFunc, doorHeightValueToFunc, passSelectedDoor]); // Trigger effect whenever doorSizeValue changes

    const handleTransomLiteChange = (e) => {
        const newValue = e.target.value;
        setSelectedTransomLite(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="TransomLite">{label}</label>
            <select style={{ display: "none" }}
                id="TransomLite"
                value={selectedTransomLite}
                onChange={handleTransomLiteChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="MatchDoorLite">{selectedTransomLite === "MatchDoorLite" ? "Match Door Lite ✔" : "Match Door Lite"}</option>
              {passSelectedDoor && ![1, 5].includes(passSelectedDoor.id) && (
              <option value="MatchSideLite">{selectedTransomLite === "MatchSideLite" ? "Match Side Lite ✔" : "Match Side Lite"}</option>
            )}
              <option value="Other">{selectedTransomLite === "Other" ? "Other ✔" : "Other"}</option>
            </select>
        </div>
    );
};

export default TransomLite;
